// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bookmark-solid';

export const Component = () => (
  <path d='M19.745 1.485v22.558c0 .335-.192.479-.527.479-.144 0-.24-.048-.288-.144l-6.082-5.747-6.034 5.747a.434.434 0 0 1-.335.144c-.335 0-.479-.144-.479-.479V1.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 7.485 0h10.776c.431 0 .766.144 1.054.431.287.288.431.623.431 1.054h-.001Z' />
);

export const viewBox = '0 0 25 25';
